import * as React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { PriceFormSchemaType, ProductPricesForm } from '@/components/form/product/product-prices-form'

interface VariantPricesFormSectionProps {
    storeId: string
}


export const VariantPricesFormSection = ({ storeId }: VariantPricesFormSectionProps) => {
    const { t } = useTranslation(['products', 'common'])
    const { watch, setValue } = useFormContext()

    const prices = watch('prices') || []
    const handleUpdatePrices = (updatedPrices: PriceFormSchemaType[]) => {
        setValue('prices', updatedPrices, { shouldDirty: true })
    }

    return (
        <Card>
            <CardHeader>
                <div>
                    <CardTitle>{t('prices')}</CardTitle>
                    <p className="text-muted-foreground text-sm mt-1">
                        {t('pricesDescription')}
                    </p>
                </div>
            </CardHeader>
            <CardContent>
                <ProductPricesForm
                    prices={prices}
                    onUpdatePrices={handleUpdatePrices}
                    variantIndex={0}
                    storeId={storeId}
                />
            </CardContent>
        </Card>
    )
}

